import { useInfiniteQuery } from 'react-query';

import { ACTIVE_USERS_KEY, getActiveUsers } from '@utils/backend-api/organizations';

const useOrganizationActiveUsers = (searchTerm = '') => {
  return useInfiniteQuery(
    [ACTIVE_USERS_KEY, searchTerm],
    ({ pageParam = 1 }) => getActiveUsers({ pageParam, searchTerm }),
    {
      getNextPageParam: (lastPage) => (lastPage.hasNextPage ? lastPage.currentPage + 1 : undefined),
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
    }
  );
};

export default useOrganizationActiveUsers;
